/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInstitution } from 'app/shared/model/institution.model';
import { ICashTransaction } from 'app/shared/model/cash-transaction.model';
import { IInsuranceClaim } from 'app/shared/model/insurance-claim.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { IPackageSubscriber } from 'app/shared/model/package-subscriber.model';
import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { BillOrigin } from 'app/shared/model/enumerations/bill-origin.model';

export interface IHospitalPayment {
  id?: string;
  writtenOn?: dayjs.Dayjs | null;
  toRealizeOn?: dayjs.Dayjs | null;
  paymentMethod?: keyof typeof PaymentMethod | null;
  realized?: boolean | null;
  realizedOn?: dayjs.Dayjs | null;
  realizationComments?: string | null;
  comments?: string | null;
  chequeRefNo?: string | null;
  chequeDate?: dayjs.Dayjs | null;
  creditCardRefNo?: string | null;
  transactionRefNo?: string | null;
  paidValue?: number | null;
  insuranceRefNo?: string | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  paymentStatus?: keyof typeof PaymentStatus | null;
  billOrigin?: keyof typeof BillOrigin | null;
  collectedById?: string | null;
  collectedByType?: string | null;
  lastUpdatedById?: string | null;
  gatewayVendor?: string | null;
  accountOrCardNo?: string | null;
  accountHolderName?: string | null;
  cardExpiryDate?: number | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  insuranceOrBank?: IInstitution | null;
  cashTransaction?: ICashTransaction | null;
  claim?: IInsuranceClaim | null;
  admission?: IAdmission | null;
  bill?: IHospitalBill | null;
  subscriber?: IPackageSubscriber | null;
}

export const defaultValue: Readonly<IHospitalPayment> = {
  realized: false,
  active: false,
  voided: false,
};
